import { apiCall } from './gqlClient';

const ATHLETEMEALLOGS_QUERY = `
  query athleteMealLogs($athleteProfileId: String!, $fromDate: String, $toDate: String) {
    athleteMealLogs(athleteProfileId: $athleteProfileId, fromDate: $fromDate, toDate: $toDate)
    {
      id
			athleteProfileId
			nutritionPlanId
			logDate
			calories
			proteinG
			carbsG
			fatG
			note
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const athleteMealLogsApiCall = async ({athleteProfileId, fromDate, toDate}, fragments = null) => apiCall({ query: ATHLETEMEALLOGS_QUERY, variables: {athleteProfileId, fromDate, toDate}, fragments });

const ATHLETENUTRITIONDAY_QUERY = `
  query athleteNutritionDay($athleteNutritionPlanId: String!, $logDate: String!) {
    athleteNutritionDay(athleteNutritionPlanId: $athleteNutritionPlanId, logDate: $logDate)
    {
      athleteNutritionPlanId
			athleteProfileId
			nutritionPlanId
			logDate
			weekNumber
			phaseName
			targets
      ...fragments
    }
  }`;

export const athleteNutritionDayApiCall = async ({athleteNutritionPlanId, logDate}, fragments = null) => apiCall({ query: ATHLETENUTRITIONDAY_QUERY, variables: {athleteNutritionPlanId, logDate}, fragments });

const ATHLETENUTRITIONADHERENCE_QUERY = `
  query athleteNutritionAdherence($athleteNutritionPlanId: String!, $toDate: String) {
    athleteNutritionAdherence(athleteNutritionPlanId: $athleteNutritionPlanId, toDate: $toDate)
    {
      weekNumber
			phaseName
			fromDate
			toDate
			days
			plannedMeals
			doneMeals
			skippedMeals
			loggedDays
			avgCalories
			avgProteinG
			avgCarbsG
			avgFatG
			targets
      ...fragments
    }
  }`;

export const athleteNutritionAdherenceApiCall = async ({athleteNutritionPlanId, toDate}, fragments = null) => apiCall({ query: ATHLETENUTRITIONADHERENCE_QUERY, variables: {athleteNutritionPlanId, toDate}, fragments });

const PROVIDERNUTRITIONADHERENCE_QUERY = `
  query providerNutritionAdherence($toDate: String) {
    providerNutritionAdherence(toDate: $toDate)
    {
      athleteNutritionPlanId
			athleteProfileId
			title
			fromDate
			toDate
			days
			plannedMeals
			doneMeals
			skippedMeals
			loggedDays
			lastLogDate
			avgCalories
			targetKcal
      ...fragments
    }
  }`;

export const providerNutritionAdherenceApiCall = async ({toDate}, fragments = null) => apiCall({ query: PROVIDERNUTRITIONADHERENCE_QUERY, variables: {toDate}, fragments });

const ATHLETEMEALDETAIL_QUERY = `
  query athleteMealDetail($athleteNutritionPlanId: String!, $mealTemplateId: String!, $language: String) {
    athleteMealDetail(athleteNutritionPlanId: $athleteNutritionPlanId, mealTemplateId: $mealTemplateId, language: $language)
    {
      mealTemplateId
			name
			description
			coverUrl
			caloriesKcal
			proteinG
			carbG
			fatG
			fiberG
      ...fragments
    }
  }`;

export const athleteMealDetailApiCall = async ({athleteNutritionPlanId, mealTemplateId, language}, fragments = null) => apiCall({ query: ATHLETEMEALDETAIL_QUERY, variables: {athleteNutritionPlanId, mealTemplateId, language}, fragments });

const LOGATHLETEMEAL_QUERY = `
  mutation logAthleteMeal($input: AthleteMealLogInput!) {
    logAthleteMeal(input: $input)
    {
      id
			athleteProfileId
			nutritionPlanId
			logDate
			calories
			proteinG
			carbsG
			fatG
			note
			createdAt
			updatedAt
      ...fragments
    }
  }`;

export const logAthleteMealApiCall = async ({input}, fragments = null) => apiCall({ query: LOGATHLETEMEAL_QUERY, variables: {input}, fragments });

const CHECKATHLETEMEAL_QUERY = `
  mutation checkAthleteMeal($input: AthleteMealCheckInput!) {
    checkAthleteMeal(input: $input)
    {
      athleteNutritionPlanId
			athleteProfileId
			nutritionPlanId
			logDate
			weekNumber
			phaseName
			targets
      ...fragments
    }
  }`;

export const checkAthleteMealApiCall = async ({input}, fragments = null) => apiCall({ query: CHECKATHLETEMEAL_QUERY, variables: {input}, fragments });
